/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewNameItem
 */
export interface CRSFSecReviewNameItem {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewNameItem
     */
    Email: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewNameItem
     */
    Name: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewNameItem
     */
    Type: number;
}

/**
 * Check if a given object implements the CRSFSecReviewNameItem interface.
 */
export function instanceOfCRSFSecReviewNameItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "Email" in value;
    isInstance = isInstance && "Name" in value;
    isInstance = isInstance && "Type" in value;

    return isInstance;
}

export function CRSFSecReviewNameItemFromJSON(json: any): CRSFSecReviewNameItem {
    return CRSFSecReviewNameItemFromJSONTyped(json, false);
}

export function CRSFSecReviewNameItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewNameItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'Email': json['Email'],
        'Name': json['Name'],
        'Type': json['Type'],
    };
}

export function CRSFSecReviewNameItemToJSON(value?: CRSFSecReviewNameItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Email': value.Email,
        'Name': value.Name,
        'Type': value.Type,
    };
}

